<script>
  import { _ as t } from "svelte-i18n";
  import { authToken } from "stores.js";

  import Button from "components/Button.svelte";

  const eventRegistrationUrl = "https://app.oniva.events/event/tag-der-parlamente-2025";
</script>

<div class="closed-registration">
  {#if !$authToken}
    <a href={eventRegistrationUrl} class="registration-link" target="_blank" rel="noopener noreferrer">
      <Button>{$t("event.accessForMore")}</Button>
    </a>
  {/if}
</div>

<style>
  .closed-registration {
    text-align: center;
    margin: 24px 0;
  }

  .registration-link {
    text-decoration: none;
  }
</style>
